import { useContext, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./components/Home/Home";
import HomeOrders from "./components/Home/Orders/Orders";
import Zones from "./components/Zones/Zones";
import Customers from "./components/Customers/Customers";
import Orders from "./components/Orders/Orders";
import Login from "./components/Login/Login";
import { AuthContext } from "./context/authContext";
import NewOrder from "./components/Home/NewOrder/NewOrder";
import Categories from "./components/Orders/Categories/Categories";
import Dishes from "./components/Orders/Dishes/Dishes";
import AllOrders from "./components/Orders/AllOrders/AllOrders";
import Checkout from "./components/Orders/Checkout/Checkout";
import ThankYou from "./components/Orders/ThankYou/ThankYou";
import Layout from "./components/Layout/Layout";
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();

  const authContext = useContext(AuthContext);

  useEffect(() => {
    document.dir = i18n.dir();
  }, [i18n, i18n.language]);

  let routes = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );

  if (authContext.loggedInUser && authContext.token) {
    routes = (
      <Layout>
        <Routes>
          <Route path="/home/*" element={<Home />}>
            <Route path="orders" element={<HomeOrders />} />
            <Route path="new-order" element={<NewOrder />} />
            <Route path="*" element={<Navigate to="orders" />} />
          </Route>
          <Route path="/zones/*" element={<Zones />} />
          <Route path="/customers/*" element={<Customers />} />
          <Route path="/orders/*" element={<Orders />}>
            <Route path="categories" element={<Categories />} />
            <Route path="categories/dishes" element={<Dishes />} />
            <Route path="all" element={<AllOrders />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="thank-you" element={<ThankYou />} />
            <Route path="*" element={<Navigate to="categories" />} />
          </Route>
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </Layout>
    );
  }

  return <div className="App">{routes}</div>;
}

export default App;
